export default __webpack_public_path__ + "static/media/LuckiestGuy-Regular.fd5a8f5e.ttf";